import { AccountType } from '@mnz-core/models/_enums';
import { IMessage } from '@mnz-core/models/message';
import { createAction, props } from '@ngrx/store';

export const resetAccount = createAction(
  '[Account] Reset Account',
  props<{ email: string; accountType: AccountType }>()
);
export const resetAccountFail = createAction('[Account] Reset Account Fail');
export const resetAccountSuccess = createAction('[Account] Reset Account Success', props<{ message: IMessage }>());

export const activateAccount = createAction('[Account] Activate Account', props<{ email: string }>());
export const activateAccountFail = createAction('[Account] Activate Account Fail');
export const activateAccountSuccess = createAction(
  '[Account] Activate Account Success',
  props<{ message: IMessage }>()
);
